<ng-container *ngIf="viewMode ==='create'">
<wms-wizard *ngIf="webSocketService.ws.stepCount > 0  && wizardSteps?.length"
    [steps]="wizardSteps" [counter]="webSocketService.ws.stepCount-1"></wms-wizard>
<div class="wm-form websocket" *ngIf="webSocketService.ws.stepCount">
    <wms-message [scopeDataset]="webSocketService.webServiceMessage"></wms-message>

    <!-- Service Configuration Steps -->
    <div class="full-height">
        <div class="web-socket-container full-width">
            <!-- Step 1 Screen -->
            <ng-container *ngIf="webSocketService.ws.stepCount === 1">
                <wms-test (testRun)="test()" (urlChange)="onUrlChange($event)" [ws]="webSocketService.ws" [testDisabled]="testDisabled" [disableDialogActions]="webSocketService.disableDialogActions"></wms-test>
            </ng-container>

            <!-- Step 2 Screen -->
            <ng-container *ngIf="webSocketService.ws.stepCount === 2">
                <wms-config  (urlChange)="onUrlChange($event)" (addParam)="addParam($event)" (removeParam)="removeParam($event)"></wms-config>
            </ng-container>
        </div>
    </div>
</div>
</ng-container>

<ng-container *ngIf="viewMode ==='edit'">
    <div class="wm-workspace">
        <div class="full-height">
<!--            <div class="workspace-header">-->
<!--                <div class="wm-actions-left">-->
<!--                    <ul class="tabs btn-group">-->
<!--                        <li class="active">-->
<!--                          <button class="btn ng-binding" title="Service Settings">-->
<!--                            {{ locale.LABEL_WORKSPACE_WEB_SERVICE_SETTINGS }}-->
<!--                          </button>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                </div>-->
<!--                <div class="wm-actions-right">-->
<!--                    <ul>-->
<!--                        <li>-->
<!--                          <ul class="ng-scope">-->
<!--                            <li class="btn-group">-->
<!--                              <button (click)="webSocketService.updateService()" class="wm-workspace-action wm-icon24 wms wms-save"-->
<!--                                [title]="locale.LABEL_SAVE"-->
<!--                                [disabled]="!webSocketService.ws.serviceTested || (webSocketService.ws.isUrlChanged && !webSocketService.ws.isUrlTested)"></button>-->
<!--                            </li>-->
<!--                            <li class="btn-group">-->
<!--                                <button name="wm-webservice-delete"-->
<!--                                [title]="locale.LABEL_DELETE"-->
<!--                                  class="wm-icon24 wms wms-delete wm-workspace-action" (click)="-->
<!--                                  webSocketService.deleteWebService($event)-->
<!--                                "></button>-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </li>-->

<!--                      </ul>-->
<!--                </div>-->
<!--            </div>-->
            <div class="workspace-content web-service-container">
                <wms-message [scopeDataset]="webSocketService.webServiceMessage"></wms-message>
                <wms-config *ngIf="serviceId"  [inputParams]="webSocketService.ws.inputParams" [serviceId]="serviceId" (urlChange)="onUrlChange($event)" (testRun)="test()" (addParam)="addParam($event)" (removeParam)="removeParam($event)"></wms-config>
            </div>
        </div>
    </div>
</ng-container>
